import React from "react";
import { Link } from "react-router-dom";

const ResumeIcon: React.FC = () => {
  return (
    <Link to="/resume" target="_blank" className="link">
      <div className="anchor-link">
        <svg
          data-name="Layer 1"
          id="Layer_1"
          viewBox="0 0 32 32"
          width="20px"
          height="20px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs></defs>
          <title />
          <path
            className="cls-1"
            fill="#999"
            d="M26.66,9.63a.25.25,0,0,1,0-.07,4.28,4.28,0,0,0-.79-1.15L20.59,3.17A4,4,0,0,0,17.76,2H8A3,3,0,0,0,5,5V27a3,3,0,0,0,3,3H24a3,3,0,0,0,3-3V11.24A4,4,0,0,0,26.66,9.63ZM20,5.41,23.59,9H21a1,1,0,0,1-1-1ZM25,27a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V5A1,1,0,0,1,8,4h9.76L18,4V8a3,3,0,0,0,3,3h4a1.94,1.94,0,0,1,0,.24Z"
          />
          <path
            className="cls-1"
            fill="#999"
            d="M22,13H19a1,1,0,0,0,0,2h3a1,1,0,0,0,0-2Z"
          />
          <path
            className="cls-1"
            fill="#999"
            d="M22,18H10a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2Z"
          />
          <path
            className="cls-1"
            fill="#999"
            d="M22,22H10a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2Z"
          />
          <path
            className="cls-1"
            fill="#999"
            d="M10,16a1,1,0,0,0,1-1,2.11,2.11,0,0,1,.86-.64,2,2,0,0,0,.84-.41,1.63,1.63,0,0,0,.31,0,1.73,1.73,0,0,0,.32,0,2,2,0,0,0,.85.41,2.24,2.24,0,0,1,.83.62A1,1,0,0,0,17,15c0-1.24-1.3-2.05-1.93-2.34a4.24,4.24,0,0,0,.43-2.16A2.6,2.6,0,0,0,13,8a2.6,2.6,0,0,0-2.5,2.5,4.24,4.24,0,0,0,.43,2.16C10.3,13,9,13.76,9,15A1,1,0,0,0,10,16Zm3-6a.64.64,0,0,1,.5.5c0,.75,0,1.1-.46,1.54H13c-.44-.44-.46-.79-.46-1.54A.64.64,0,0,1,13,10Z"
          />
        </svg>
      </div>
    </Link>
  );
};

export default ResumeIcon;
